import type { ContainerImageListOptions, ImageListState, ImageQuery } from '../types';
import { useCommonImageListState } from './useCommonImageListState';
import { useContainerImageListState } from './useContainerImageListState';

/** 弹窗镜像列表：按 variant 选用 hook，避免条件调用 hook */
export function useImageSelectModalListState(
  variant: 'common' | 'container',
  queryObj: ImageQuery,
  options: ContainerImageListOptions,
): ImageListState {
  const disabledOptions: ContainerImageListOptions = { ...options, enabled: false };
  const commonListState = useCommonImageListState(queryObj, variant === 'common' ? options : disabledOptions);
  const containerListState = useContainerImageListState(queryObj, variant === 'container' ? options : disabledOptions);
  return variant === 'container' ? containerListState : commonListState;
}
